import { AxiosError } from 'axios'

const SUPPORT_ERROR_MESSAGE = 'サポートにお問い合わせください'
const SUSPENDED_ERROR_MESSAGE = '入力回数が上限に達しました。10分後に再度お試しください'
const OTP_INVALID_ERROR_MESSAGE = '認証コードが正しくありません'
const OTP_EXPIRED_ERROR_MESSAGE = 'コードの有効期限が切れました。再送してください。'
const OTP_RESEND_WAIT_ERROR_MESSAGE = '1分経過後に再送できます'

export type MfaErrorCode = 'otp_verification_failed' | 'otp_send_unavailable'
type MfaErrorReason = 'suspended' | 'expired' | 'wait_required' | 'mismatch' | 'already_verified'
export type MfaErrorResponse = {
  errorCode?: string
  messageParameter?: {
    reason?: string
  }
}

const mfaErrorMessageByCode: Record<
  MfaErrorCode,
  {
    defaultMessage: string
    reasonMessages: Partial<Record<MfaErrorReason, string>>
  }
> = {
  otp_verification_failed: {
    defaultMessage: OTP_INVALID_ERROR_MESSAGE,
    reasonMessages: {
      suspended: SUSPENDED_ERROR_MESSAGE,
      expired: OTP_EXPIRED_ERROR_MESSAGE,
      mismatch: OTP_INVALID_ERROR_MESSAGE,
      already_verified: OTP_EXPIRED_ERROR_MESSAGE,
    },
  },
  otp_send_unavailable: {
    defaultMessage: SUPPORT_ERROR_MESSAGE,
    reasonMessages: {
      suspended: SUSPENDED_ERROR_MESSAGE,
      wait_required: OTP_RESEND_WAIT_ERROR_MESSAGE,
    },
  },
}

export const getMfaErrorMessage = (error: AxiosError<MfaErrorResponse>, expectedErrorCode: MfaErrorCode) => {
  const responseData = error.response?.data
  if (responseData?.errorCode !== expectedErrorCode) {
    return SUPPORT_ERROR_MESSAGE
  }

  const messageBag = mfaErrorMessageByCode[expectedErrorCode]
  const reason = responseData.messageParameter?.reason as MfaErrorReason | undefined
  if (!reason) {
    return messageBag.defaultMessage
  }
  return messageBag.reasonMessages[reason] ?? messageBag.defaultMessage
}
